import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  DataTable,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  Loading,
  InlineNotification,
  Tag,
  FormGroup,
} from "carbon-components-react";
import { Download32, Document32 } from "@carbon/icons-react";
import http from "../../http-common";
import { getDocumentTypeDescription } from "../../services/Utils";

const TeamMemberList = ({ applicationUuid }) => {
  const [teamMembers, setTeamMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTeamMembers();
  }, [applicationUuid]);

  const fetchTeamMembers = async () => {
    try {
      setLoading(true);
      const response = await http.get(
        `/applications/${applicationUuid}/team-members`
      );
      setTeamMembers(response.data);
      setError(null);
    } catch (err) {
      console.error("Error fetching team members:", err);
      setError(
        "Erro ao carregar membros da equipe: " +
          (err.response?.data?.message || err.message)
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = async (doc) => {
    try {
      // console.log("Starting download for team member document:", doc);
      // console.log(
      //   "Download URL:",
      //   `/applications/documents/download/${doc.id}`
      // );

      const response = await http.get(
        `/applications/documents/download/${doc.id}`,
        { responseType: "blob" }
      );

      // console.log("Download response:", response);
      // console.log("Response data type:", typeof response.data);
      // console.log("Response data size:", response.data.size);

      if (!response.data || response.data.size === 0) {
        throw new Error("Document is empty or not found");
      }

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = doc.fileName || "document";
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      // console.log("Download completed successfully");
    } catch (err) {
      console.error("Error downloading document:", err);
      console.error("Error details:", err.response);
      setError(
        "Erro ao baixar documento: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  if (loading) {
    return <Loading description="Carregando membros da equipe..." />;
  }

  if (error) {
    return (
      <InlineNotification
        kind="error"
        title="Erro"
        subtitle={error}
        className="mb-4"
      />
    );
  }

  // if (teamMembers.length === 0) {
  //   return (
  //     <InlineNotification
  //       kind="info"
  //       title="Sem membros"
  //       subtitle="Nenhum membro da equipe encontrado para esta candidatura"
  //       className="mb-4"
  //     />
  //   );
  // }

  return (
    <div className="team-member-list">
      {error && (
        <InlineNotification
          kind="error"
          title="Erro"
          subtitle={error}
          onCloseButtonClick={() => setError(null)}
          className="mb-4"
        />
      )}
      <FormGroup
        legendText="EQUIPA DE DESENVOLVIMENTO DA PLATAFORMA"
        className="section-header"
      >
        <Accordion>
          {teamMembers.map((member) => (
            <AccordionItem
              key={member.id}
              title={
                <div className="member-header">
                  <span className="member-name">
                    {member.name} ({member.role})
                  </span>
                </div>
              }
            >
              <div className="member-details p-4">
                <h6 className="text-lg font-medium">Actividades:</h6>
                <p className="mb-4 whitespace-pre-line">
                  {member.activities || "Nenhuma atividade especificada"}
                </p>

                {member.documents && member.documents.length > 0 ? (
                  <div>
                    <h6 className="text-lg font-medium">Documentos:</h6>
                    <Table size="sm">
                      <TableHead>
                        <TableRow>
                          <TableHeader>Nome do Documento</TableHeader>
                          <TableHeader>Tipo de Documento</TableHeader>
                          <TableHeader>Tamanho</TableHeader>
                          <TableHeader>Ações</TableHeader>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {member.documents.map((doc) => (
                          <TableRow key={doc.id}>
                            <TableCell>
                              <div className="flex items-center">
                                {doc.fileName}
                              </div>
                            </TableCell>
                            <TableCell>
                              {getDocumentTypeDescription(doc.documentType)}
                            </TableCell>

                            <TableCell>
                              {doc.size
                                ? `${(doc.size / 1024 / 1024).toFixed(2)} MB`
                                : "-"}
                            </TableCell>
                            <TableCell>
                              <button
                                onClick={() => {
                                  // console.log(
                                  //   "Download button clicked for team member document:",
                                  //   doc
                                  // );
                                  handleDownload(doc);
                                }}
                                className="bx--btn bx--btn--ghost bx--btn--sm"
                                title="Baixar documento"
                              >
                                <Download32 />
                              </button>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                ) : (
                  <InlineNotification
                    kind="info"
                    title="Sem documentos"
                    subtitle="Este membro não possui documentos anexados"
                    className="mt-4"
                  />
                )}
              </div>
            </AccordionItem>
          ))}
        </Accordion>
      </FormGroup>
    </div>
  );
};

export default TeamMemberList;
